import RecruitmentFamilyItem from './recruitment-family-item';

export default RecruitmentFamilyItem;
